import { ReceiptState, ReceiptStateValue } from '@interfaces/receipts';
import { Source } from '@interfaces/source';

export function checkIfUploadingIsAllowed(
  source: Source,
  receiptsState?: ReceiptState | null
) {
  const config = receiptsState?.source[source];
  return (
    !!config &&
    config.upload_allowed &&
    config.state !== ReceiptStateValue.disabled
  );
}
